export default class Blocks {
    private window: any = window;
    public static readonly desktopBreakpoint = 992;
    private readonly needConsentClass = "need-cookie-consent";
   
    constructor() {
        this.updateEqualHeights();
        this.setListeners();
    }

    private setListeners() {
        $(this.window).resize(() => {
            this.updateEqualHeights();
        });
    }

    private updateEqualHeights() {
        const winWidth = $(this.window).width();

        $('.equal-height').each((i, e) => {
            let breakPoint = parseInt($(e).data("equal-break-point")) || Blocks.desktopBreakpoint;

            const el: any = $('.equalize', $(e));
            if (winWidth > breakPoint) {
                el.matchHeight(false);
            }
            else {
                el.matchHeight("remove");
            }
        });
    }
}

$(function () {
    $(document).on('click', 'img[data-image]', function (event) {
        var target = $(event.currentTarget).data('target');
        var targetimg = $(target);
        var img = $(event.currentTarget).data('image');
        img = img.split('?')[0];
        $(event.currentTarget).closest('.product-thumbs').find('.selected').removeClass('selected');
        $(event.currentTarget).addClass('selected');
        targetimg.attr('src', img + "?w=798&h=300&mode=crop");
    });

    if ($('form.product-picker').length > 0) {
        var setProductImages = function (id, images) {
            var qsSmall = "?w=200&h=100&mode=crop"; 
            var qslarge = "?w=798&h=300&mode=crop"; 
            if (typeof (images[0]) != 'undefined') {
                $('#product-image-' + id).attr('src', images[0] + qslarge);
            }
                
            var thumbs = $('[data-target="#product-image-' + id + '"]');
            // add placeholder that is shown while the new image is loading
            thumbs.attr('src', "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7");
            thumbs.addClass("hidden");

            for (var i = 0; i < images.length; i++) {
                $(thumbs[i])
                    .attr('src', images[i] + qsSmall)
                    .attr('data-image', images[i])
                    .data('image', images[i])
                    .removeClass("hidden");
            }
        }
        $('form.product-picker').each(function () {

            $(this).find('[name="color"]').on('change', function (event) {
                $(this).parent().submit();
            });
            $(this).on('submit', function (event) {
                event.preventDefault();
                var form = $(this);
                $.ajax({
                    type: form.data("method"),
                    url: form.data("action"),
                    data: form.serialize()
                }).done(function (data) {
                    var images = data;//JSON.parse(data);
                    var id = form.data('id')
                    setProductImages(id, images);
                }).fail(function (data) {
                    // Error ?
                    console.error(data);
                });
            });
        });
    }
});